import { configureStore } from '@reduxjs/toolkit';
import adminStatsReducer from './adminStatsSlice';
import adminUsersReducer from './adminUsersSlice';
import adminProductsReducer from './adminProductsSlice';
import adminOrdersReducer from './adminOrdersSlice';
import adminPayoutsReducer from './adminPayoutsSlice';

export const store = configureStore({
  reducer: {
    adminStats: adminStatsReducer,
    adminUsers: adminUsersReducer,
    adminProducts: adminProductsReducer,
    adminOrders: adminOrdersReducer,
    adminPayouts: adminPayoutsReducer,
  },
});
